import React, { useState } from 'react';
import { compose } from 'redux';
import Breadcrumb from '@components/Breadcrumb';
import ContainerBody from '@components/ContainerBody';
import { withPaginate } from '@contexts/Paginate/PaginateContext';
import ListUserOperator from './components/ListUserOperator';
import { useNavigate } from 'react-router-dom';
import { useRole } from '@contexts/Auth/UseRole';
import Page403 from '@page/Common/403/403';

const ManageUserOperator = () => {
  const navigate = useNavigate();
  const { isWebSuperAdmin } = useRole();
  return (
    <>
      {isWebSuperAdmin ? (
        <ContainerBody>
          <div className="breadcrumb">
            <Breadcrumb
              homePath={'/customer/dashboard'}
              routeSegments={[{ name: 'Quản lý người dùng' }]}
            />
          </div>
          <ListUserOperator />
        </ContainerBody>
      ) : (
        <Page403 />
      )}
    </>
  );
};

export default compose(withPaginate)(ManageUserOperator);
